module.exports = __webpack_public_path__ + "media/images/Groupe_left-c06f295bf750615a27d9104aa8e93013.svg";